export default __webpack_public_path__ + "static/media/1623166453450.e8241e05.png";